import { createContext } from "react";

export interface DilutionListModeContextType {
  mode: "card" | "list";
  setMode: (mode: "card" | "list") => void;
}

export const DilutionListModeContext =
  createContext<DilutionListModeContextType | null>(null);
